import {defineMessages} from 'react-intl';

const messages = defineMessages({
  formField_domainPassword: {
    id: 'formField_domainPassword',
    defaultMessage: 'Password'
  },
  formField_workspacePassword: {
    id: 'formField_workspacePassword',
    defaultMessage: 'Workspace password'
  },
  signIn: {
    id: 'signIn',
    defaultMessage: 'Sign in'
  },
  allSignInOptions: {
    id: 'allSignInOptions',
    defaultMessage: 'All sign in options'
  },
  forgotYourPassword: {
    id: 'forgotYourPassword',
    defaultMessage: 'Forgot your password?'
  },
  email: {
    id: 'common.forms.email',
    defaultMessage: 'Email'
  },
  forgotWorkspacePassword: {
    id: 'forgotWorkspacePassword',
    defaultMessage: 'Forgot your workspace password?'
  },
  invalidEmail: {
    id: 'invalidEmail',
    defaultMessage: 'Invalid email address.'
  },
  wrongEmailOrPassword: {
    id: 'wrongEmailOrPassword',
    defaultMessage: 'Wrong email or password.'
  },
  wrongEmailOrPasswordFourTimes: {
    id: 'wrongEmailOrPasswordFourTimes',
    defaultMessage: 'Wrong email or password. Check our {helpArticle} if you experience trouble signing in.'
  },
  doesNotHaveAccess: {
    id: 'doesNotHaveAccess',
    defaultMessage: 'You don’t have access to this workspace. Make sure you are using the right link.'
  },
  canNotSignIn: {
    id: 'canNotSignIn',
    defaultMessage: 'Couldn’t sign in to workspace'
  },
  wrongEmailOrPasswordTenTimes: {
    id: 'wrongEmailOrPasswordTenTimes',
    defaultMessage:
      'Your account is blocked after too many failed sign in attempts. To unblock your account, request a {passwordResetLink}.'
  },
  wrongWorkspacePassword: {
    id: 'wrongWorkspacePassword',
    defaultMessage: 'Wrong workspace password.'
  },
  tooManyFailedAttempts: {
    id: 'tooManyFailedAttempts_contactAdmin',
    defaultMessage:
      'Too many failed sign in attempts. Contact your platform admin to provide the correct workspace password to avoid getting locked out.'
  },
  tooManyFailedAttemptsBlocked: {
    id: 'tooManyFailedAttemptsBlocked_contactAdmin',
    defaultMessage:
      'You are locked out after too many failed sign in attempts. Contact your platform admin to reset the login attempts.'
  },
  helpArticle: {
    id: 'helpArticle',
    defaultMessage: 'help article'
  },
  passwordResetLink: {
    id: 'passwordResetLink',
    defaultMessage: 'password reset link'
  },
  cantSignInToWorkspace: {
    id: 'cantSignInToWorkspace',
    defaultMessage: 'Couldn’t sign in to workspace'
  },
  wrongCurrent10thTime: {
    id: 'wrongCurrent10thTime',
    defaultMessage:
      'Your account is blocked after you entered the wrong password too many times. To unblock your account, request a {passwordResetLink}'
  }
});

export default messages;
